import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography, CircularProgress } from "@mui/material";

import Blog from "./blog";
import BlogSidebar from "./blogsidebar";
import Page from "src/components/Page";

const WORDPRESS_API = "https://apiblog.leon-gallery.com/wp-json/wp/v2/";
const DEFAULT_CATEGORIES = "3,4";
const POSTS_PER_PAGE = 10;

export default function Index() {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = Number(searchParams.get("page")) || 1;
  const currentCategories = searchParams.get("categories") || DEFAULT_CATEGORIES;

  
  const handleCategoryChange = useCallback((categoryIds) => {
    localStorage.removeItem("@storeAuctionLot");
    setSearchParams({ page: 1, categories: categoryIds });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setSearchParams]);

  const handlePageChange = useCallback((page) => {
    setSearchParams({ page, categories: currentCategories });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setSearchParams, currentCategories]);

  /* ==============================
      Data Fetching
  ============================== */
  useEffect(() => {
    setIsLoading(true);
    const categoriesRequest = axios.get(`${WORDPRESS_API}categories`, {
      params: { _fields: "id,count,name,slug", include: DEFAULT_CATEGORIES },
    });
    const postsRequest = axios.get(`${WORDPRESS_API}posts`, {
      params: {
        _embed: "wp:featuredmedia,wp:term",
        _fields: "id,date,slug,title,excerpt,_links",
        order: "desc",
        categories: currentCategories,
        per_page: POSTS_PER_PAGE,
        page: currentPage,
      },
    });

    axios.all([categoriesRequest, postsRequest])
      .then(axios.spread((categoriesRes, postsRes) => {
        setCategories(categoriesRes.data);
        setPosts(postsRes.data);
        setTotalResults(Number(postsRes.headers["x-wp-total"]));
        setTotalPages(Number(postsRes.headers["x-wp-totalpages"]));
      }))
      .catch((err) => console.error("Blog fetch error:", err))
      .finally(() => setIsLoading(false));
  }, [currentCategories, currentPage]);

  return (
    <Page title="Stories | Leon Gallery">
      
      <Box sx={{ background: "#f4f3f3", py: 8, textAlign: "center" }}>
        <div className="container">
          
          <Typography 
            variant="h2" 
            sx={{ fontFamily: "serif", fontWeight: 700, mt: 1, color: "#2d353d" }}
          >
            Latest Stories
          </Typography>
        </div>
      </Box>

      
      <Box sx={{ background: "#ffffff", py: { xs: 4, md: 8 } }}>
        <div className="container">
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
              <CircularProgress color="inherit" />
            </Box>
          ) : (
            <div className="row">
              
              <div className="col-xl-3 col-lg-4">
                <Box sx={{ mb: { xs: 5, lg: 0 } }}>
                  <BlogSidebar
                    categoriesList={categories}
                    totalResult={totalResults}
                    onChangeCategories={handleCategoryChange}
                  />
                </Box>
              </div>

              
              <div className="col-xl-9 col-lg-8">
                <Blog
                  listPost={posts}
                  totalPage={totalPages}
                  currentPage={currentPage}
                  setPage={handlePageChange}
                />
              </div>
            </div>
          )}
        </div>
      </Box>
    </Page>
  );
}